/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Backward': {
    width: 21,
    height: 17,
    viewBox: '0 0 21 17',
    data: '<path pid="0" d="M13.24 3.086a1.2 1.2 0 10-1.658-1.736l-6.6 6.3a1.2 1.2 0 000 1.736l6.6 6.3a1.2 1.2 0 001.657-1.736L7.55 8.518l5.69-5.432zM3.17 2.218a1.2 1.2 0 00-2.4 0v12.6a1.2 1.2 0 002.4 0v-12.6z" _fill="#00204D" _stroke="#00204D" stroke-width=".6" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M19.368 9.752a1.2 1.2 0 000-2.4H7.728a1.2 1.2 0 000 2.4h11.64z" _fill="#00204D" _stroke="#00204D" stroke-width=".6" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
